console.log("bb-script.js");

// Mega Menu Hover Functionality
document.addEventListener("DOMContentLoaded", function () {
  const megaMenus = document.querySelectorAll(".mega-menu");

  megaMenus.forEach(function (megaMenu) {
    const summary = megaMenu.querySelector("summary");
    const content = megaMenu.querySelector(".mega-menu__content");

    if (!summary || !content) return;

    let hoverTimeout;

    // Show menu on hover
    megaMenu.addEventListener("mouseenter", function () {
      clearTimeout(hoverTimeout);
      megaMenu.setAttribute("open", "");
      content.style.opacity = "1";
      content.style.visibility = "visible";
      content.style.transform = "translateY(0)";
      content.style.pointerEvents = "auto";
    });

    // Hide menu on mouse leave with delay
    megaMenu.addEventListener("mouseleave", function () {
      hoverTimeout = setTimeout(function () {
        megaMenu.removeAttribute("open");
        content.style.opacity = "0";
        content.style.visibility = "hidden";
        content.style.transform = "translateY(-1rem)";
        content.style.pointerEvents = "none";
      }, 150); // Small delay to prevent flickering
    });

    // Keep menu open when hovering over content
    content.addEventListener("mouseenter", function () {
      clearTimeout(hoverTimeout);
    });

    // Hide menu when leaving content
    content.addEventListener("mouseleave", function () {
      hoverTimeout = setTimeout(function () {
        megaMenu.removeAttribute("open");
        content.style.opacity = "0";
        content.style.visibility = "hidden";
        content.style.transform = "translateY(-1rem)";
        content.style.pointerEvents = "none";
      }, 150);
    });

    // Prevent default click behavior
    summary.addEventListener("click", function (e) {
      e.preventDefault();
    });
  });
});
// BSS B2B price configuration removed — app not installed on this store

// VAT display handled by price.liquid (Liquid template, no JS needed)
